module.exports = __webpack_public_path__ + "static/media/retirement-object-0-1-1.73f64081.svg";